import { api } from '../api';

interface QuickSightUrl {
  url: string;
}

interface QuicksightParams {
  dashboardId: string;
  region?: string;
}

export const quickSightApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getQuickSightDashboardUrl: builder.query<QuickSightUrl, QuicksightParams>({
      query: (params) => ({
        url: 'quicksight',
        method: 'GET',
        params: { 
          dashboardId: params.dashboardId,
          region: params.region
        }
      }),
    }),
  }),
});

export const {
  useGetQuickSightDashboardUrlQuery,
  useLazyGetQuickSightDashboardUrlQuery
} = quickSightApi;
